import React from 'react';

const NavBar = () => {
  const go = (path) => {
    if (window.location.hash !== path) {
      window.location.hash = path;
    }
  };

  const isActive = (path) => (window.location.hash || '#/booking') === path;

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div className="brand">Sommarstuga</div>
        <div className="links">
          <button className={`nav-link ${isActive('#/booking') ? 'active' : ''}`} onClick={() => go('#/booking')}>Bokning</button>
          <button className={`nav-link ${isActive('#/billing') ? 'active' : ''}`} onClick={() => go('#/billing')}>Fakturering</button>
          <button className={`nav-link ${isActive('#/logbook') ? 'active' : ''}`} onClick={() => go('#/logbook')}>Loggbok</button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
